import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiClock, FiMail, FiPhone } = FiIcons;

const UrgencySection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-accent-magenta/20 text-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          {/* Header */}
          <div className="flex items-center justify-center mb-8">
            <SafeIcon icon={FiClock} className="h-12 w-12 text-accent-gold mr-4" />
            <h2 className="font-playfair text-3xl lg:text-5xl font-bold">
              Your Competition Isn't Waiting—Neither Should You
            </h2>
          </div>

          {/* Main Content */}
          <div className="max-w-4xl mx-auto space-y-8 mb-12">
            <p className="text-xl leading-relaxed text-gray-100">
              The mental gap between good and great keeps widening.
            </p>
            <p className="text-lg leading-relaxed text-gray-200">
              Every game without strong executive functions is a missed chance to get ahead.
            </p>
            <div className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl border border-white/20">
              <p className="text-xl leading-relaxed text-white mb-6">
                But here's the exciting part: <span className="text-accent-gold font-semibold">your brain is incredibly trainable</span>. The right executive function training can unlock the elite performance that's been trapped by cognitive limitations.
              </p>
              <div className="space-y-4 text-lg text-gray-100">
                <p>Stop settling for "almost there" and "almost winners" performances.</p>
                <p>Stop letting mental mistakes cost you victories.</p>
                <p className="text-accent-gold font-semibold text-xl">Your championship mindset is waiting.</p>
              </div>
            </div>
          </div>

          {/* Guarantee */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="bg-accent-magenta/20 backdrop-blur-sm p-8 rounded-2xl border border-accent-magenta/30 mb-12"
          >
            <div className="flex items-center justify-center mb-4">
              <SafeIcon icon={FiClock} className="h-8 w-8 text-accent-gold mr-3" />
              <h3 className="font-playfair text-2xl font-bold text-white">
                Performance Guarantee
              </h3>
            </div>
            <p className="text-lg text-gray-100 leading-relaxed">
              We're so confident you'll dominate with sharper cognitive skills, we offer a Performance Guarantee. Train with us, complete the program, and if you don't see measurable improvement, we'll make it right.
            </p>
          </motion.div>

          {/* CTAs */}
          <div className="space-y-6">
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => {
                  const element = document.getElementById('contact');
                  if (element) element.scrollIntoView({ behavior: 'smooth' });
                }}
                className="bg-accent-gold text-gray-900 px-8 py-4 rounded-full font-bold text-lg hover:bg-accent-gold/90 transition-all duration-200 shadow-xl hover:scale-105 transform"
              >
                Book Your Game-Changer Call Today
                <span className="block text-sm font-medium mt-1">Free Consultation</span>
              </button>
              <a
                href="https://www.wethebillions.com/quiz"
                target="_blank"
                rel="noopener noreferrer"
                className="border-2 border-white text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-white hover:text-gray-900 transition-all duration-200 hover:scale-105 transform"
              >
                Take the FREE Quiz
              </a>
            </div>

            {/* Contact Info */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-gray-300">
              <div className="flex items-center gap-2">
                <SafeIcon icon={FiMail} className="h-5 w-5" />
                <span>hello@wethebillions.com</span>
              </div>
              <div className="flex items-center gap-2">
                <SafeIcon icon={FiPhone} className="h-5 w-5" />
                <span>(202) 656-0054</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default UrgencySection;